import { Injectable } from '@angular/core';
import { quizChallengeApi } from 'src/app/config/api-url';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class QuizChallengeService {

  constructor(private apiService: ApiService) { }

  createQuizChallenge(postData: any): any {
    return this.apiService.post(quizChallengeApi.createQuizChallenge, postData);
  }

  uploadQuizBanner(ReqParam: any, fileName: string): any {
    return this.apiService.postForFile(quizChallengeApi.uploadQuizBanner + fileName, ReqParam);
  }

  getQuizChallengeList(reqParam: any): any {
    return this.apiService.get(quizChallengeApi.getQuizChallengeList + reqParam);
  }

  getQuizChallengeData(param: any): any {
    return this.apiService.get(quizChallengeApi.getQuizData + param);
  }

  updateQuizChallenge(postData: any): any {
    return this.apiService.put(quizChallengeApi.createQuizChallenge, postData);
  }
}
